import {
    Directive,
    Input,
    forwardRef,
    OnDestroy,
    OnChanges,
    SimpleChanges
} from '@angular/core'
import {
    NG_VALIDATORS,
    Validator,
    AbstractControl,
    ValidationErrors
} from '@angular/forms'
import { Validators } from './validators'
import { Subscription } from 'rxjs/Subscription'

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[equalsTo]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: EqualsToDirective, multi: true }
    ]
})
export class EqualsToDirective implements Validator, OnChanges, OnDestroy {
    @Input() equalsTo: AbstractControl

    private controlToCompareSubscription: Subscription

    validate(control: AbstractControl): ValidationErrors {
        if (!this.controlToCompareSubscription) {
            this.subscribeIntoEqualsTo(control)
        }

        return Validators.equalsTo(this.equalsTo)(control)
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.equalsTo && this.controlToCompareSubscription) {
            this.unsubscribeIntoEqualsTo()
        }
    }

    ngOnDestroy() {
        if (this.controlToCompareSubscription) {
            this.unsubscribeIntoEqualsTo()
        }
    }

    private subscribeIntoEqualsTo(control: AbstractControl) {
        this.controlToCompareSubscription = this.equalsTo.valueChanges.subscribe(
            () => {
                control.updateValueAndValidity()
            }
        )
    }

    private unsubscribeIntoEqualsTo() {
        this.controlToCompareSubscription.unsubscribe()
        this.controlToCompareSubscription = null
    }
}



// WEBPACK FOOTER //
// ./src/app/common/equals-to.directive.ts